import { createActions } from 'reduxsauce';

var _createActions = createActions({
  setReceiptCode: function setReceiptCode(code1, code2) {
    return {
      type: 'SET_RECEIPT_CODE',
      code1: code1,
      code2: code2
    };
  },
  setIsLoading: function setIsLoading(isLoading) {
    return {
      type: 'SET_IS_LOADING',
      isLoading: isLoading
    };
  },
  setLocationIsLoading: function setLocationIsLoading(isLoading) {
    return {
      type: 'SET_LOCATION_IS_LOADING',
      isLoading: isLoading
    };
  },
  receiveLocation: function receiveLocation(location) {
    return {
      type: 'RECEIVE_LOCATION',
      location: location
    };
  },
  receiveOriginalCheckDetail: function receiveOriginalCheckDetail(check) {
    return {
      type: 'RECEIVE_ORIGINAL_CHECK_DETAIL',
      check: check
    };
  },
  receiveCheckDetail: function receiveCheckDetail(check) {
    return {
      type: 'RECEIVE_CHECK_DETAIL',
      check: check
    };
  },
  payOrderSuccess: function payOrderSuccess(receipt) {
    return {
      type: 'PAY_ORDER_SUCCESS',
      receipt: receipt
    };
  },
  setPayOrderPayload: function setPayOrderPayload(payload) {
    return {
      type: 'SET_PAY_ORDER_PAYLOAD',
      payload: payload
    };
  },
  setPaymentMethod: function setPaymentMethod(paymentMethod) {
    return {
      type: 'SET_PAYMENT_METHOD',
      paymentMethod: paymentMethod
    };
  },
  setGratuity: function setGratuity(payload) {
    return {
      type: 'SET_GRATUITY',
      payload: payload
    };
  },
  clearOrder: function clearOrder() {
    return {
      type: 'CLEAR_ORDER'
    };
  },
  resetCheck: function resetCheck() {
    return {
      type: 'RESET_CHECK'
    };
  } // resetError: (err) => {
  //   return {
  //     type: 'RECEIVE_RECEIPT_CODE',
  //     err: null,
  //     isError: false,
  //     receivedAt: null
  //   }
  // }

}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};